import { Bleed, Bleedable, colors, LayoutBand } from '@fs/zion-ui'
import React, { type ReactNode } from 'react'
import { MERGE_LAYOUT_MARGIN } from './helpers'
import { MARGIN_X_DEFAULT } from './layout/common'
import { useMergeIsMobile } from './providers/MergeLayoutProvider'

type DecoratorProps = {
  children: ReactNode
}

/** The sm spacer grows to 20/24px between page breakpoints, so at mobile the LayoutBand margin is escaped and
 * replaced with the card's constant 16px content padding, keeping the page gutter aligned with the card text. */
function MobileConstantGutter({ children }: DecoratorProps): JSX.Element {
  const isMobile = useMergeIsMobile()

  if (!isMobile) {
    return <>{children}</>
  }

  return (
    <Bleed sides>
      <Bleedable sides={MARGIN_X_DEFAULT}>{children}</Bleedable>
    </Bleed>
  )
}

export default function OneMergePageDecorator({ children }: DecoratorProps): JSX.Element {
  return (
    <LayoutBand marginX={MERGE_LAYOUT_MARGIN}>
      <LayoutBand color={colors.gray00} style={{ minHeight: '100vh' }}>
        <MobileConstantGutter>{children}</MobileConstantGutter>
      </LayoutBand>
    </LayoutBand>
  )
}
